import Accordion from './accordion/Accordion.vue'
import AccordionItem from './accordion/AccordionItem.vue'
import App from './App.vue'
import Container from './Container.vue'
import ContentCollapse from './ContentCollapse.vue'
import Dialog from './Dialog.vue'
import Grid from './Grid.vue'
import Position from './Position.vue'

export default {
    'tl-accordion-item': AccordionItem,
    'tl-accordion': Accordion,
    'tl-app': App,
    'tl-container': Container,
    'tl-content-collapse': ContentCollapse,
    'tl-dialog': Dialog,
    'tl-grid': Grid,
    'tl-position': Position,
}
